export default __webpack_public_path__ + "static/AURYXIA-Free-Trial-Program-flyer-2b89d6ff886dbe1f0ca4f044cca15a00.pdf";